import React from "react";
import { Module } from "../../../modules/academy/models";
import { ModuleCard } from "./ModuleCard";

export interface ModuleListProps {
  modules?: Module[];
  completedMicroCourses?: string[];
  onOpenModule?: (moduleId: string) => void;
  isKid?: boolean;
}

export function ModuleList({ modules, completedMicroCourses, onOpenModule, isKid }: ModuleListProps) {
  if (!modules || modules.length === 0) {
    return (
      <section className="rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700">
        <h2 className="text-lg font-semibold mb-2">Modules du theme</h2>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Aucun module defini pour ce theme pour l'instant.
        </p>
      </section>
    );
  }

  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Modules du theme</h2>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {modules.map((mod) => {
          const total = mod.microCourseIds.length;
          const done = mod.microCourseIds.filter((id) => completedMicroCourses?.includes(id ?? "")).length;
          const percent = total === 0 ? 0 : Math.round((done / total) * 100);
          const isCompleted = total > 0 && done === total;
          return (
            <ModuleCard
              key={mod.id}
              module={mod}
              microCoursesDone={done}
              microCoursesTotal={total}
              progressionPercent={percent}
              isCompleted={isCompleted}
              isKid={isKid}
              onOpenModule={onOpenModule}
            />
          );
        })}
      </div>
    </section>
  );
}
